import type { WeldTelemetrySampleRow } from './weldTelemetryClient'
import { DATA_360_DISPLAY_NAME } from './data360DisplayName'

export interface PassAnalyticsData360Meta {
  productionWeldId: number
  weldName: string
  jobNumber?: string
}

/** True when a sample has no usable CW/CCW Bug Type. */
export function sampleMissingBugType(sample: WeldTelemetrySampleRow): boolean {
  return sample.bugType !== 'CW' && sample.bugType !== 'CCW'
}

/** True when any sample in the list is missing CW/CCW Bug Type. */
export function samplesMissingBugType(samples: WeldTelemetrySampleRow[]): boolean {
  return samples.some(sampleMissingBugType)
}

/**
 * Read Data360 import metadata from a Welding Parameters section payload
 * (`weldparams.${weldId}`), matching WeldParameters.data360Meta.
 */
export function readData360MetaFromWeldSection(
  section: unknown,
  fallbackWeldName = ''
): PassAnalyticsData360Meta | null {
  if (!section || typeof section !== 'object') return null
  const raw = (section as Record<string, unknown>).data360
  if (!raw || typeof raw !== 'object') return null
  const meta = raw as Record<string, unknown>
  const productionWeldId =
    typeof meta.productionWeldId === 'number' ? meta.productionWeldId : null
  if (!productionWeldId) return null
  return {
    productionWeldId,
    weldName: String(meta.weldName ?? fallbackWeldName ?? '').trim(),
    jobNumber: typeof meta.jobNumber === 'string' ? meta.jobNumber : undefined
  }
}

export function data360ReimportConfirmDescription(weldLabel: string): string {
  return `Re-importing will replace all telemetry from ${DATA_360_DISPLAY_NAME} for Weld ${weldLabel}, reset tolerance to 0%, and clear all Pass Analytics selections and saved min/max overrides.`
}
